<template>
  <div class="v-radio-group">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, provide, computed, reactive } from "vue";

export default defineComponent({
  name: "VRadioGroup",
  props: {
    modelValue: {
      default: null,
      type: [String, Number]
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const state = reactive({
      value: computed(() => props.modelValue)
    });
    provide<VRadio>('radios', {
      state,
      selectRadio,
    });
    function selectRadio(radio) {
      console.log(radio)
      emit('update:modelValue', radio);
    }
  }
});
</script>